/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { CollectionGrantFragmentDoc } from "../../../../mutations/collections.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CollectionForHomeFragment = {
  readonly __typename: "Collection";
  readonly id: c.CollectionId;
  readonly name: string;
  readonly description: string | null;
  readonly emoji: string | null;
  readonly canManage: boolean;
  readonly starredByViewer: boolean;
  readonly collectionHexLinkCountsByProjectType: {
    readonly __typename: "LinkCountsByProjectType";
    readonly projectCount: number;
    readonly componentCount: number;
  };
  readonly collectionGrants: ReadonlyArray<{
    readonly __typename: "CollectionGrant";
    readonly id: c.CollectionGrantId;
    readonly role: Types.CollectionRole;
    readonly holder:
      | {
          readonly __typename: "Group";
          readonly groupId: c.GroupId;
          readonly groupName: string;
        }
      | {
          readonly __typename: "IntrinsicGroup";
          readonly intrinsicGroupId: Types.IntrinsicGroupId;
        }
      | {
          readonly __typename: "User";
          readonly name: string | null;
          readonly email: string;
          readonly active: boolean;
          readonly imageUrl: string | null;
          readonly orgRole: Types.OrgRole;
          readonly userId: c.UserId;
        };
  }>;
};

export type GetCollectionsForHome2QueryVariables = Types.Exact<{
  ownershipLevel: Types.CollectionOwnershipLevel;
  searchTerm: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  order: Types.InputMaybe<Types.CollectionOrder>;
  first: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  before: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
  after: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
}>;

export type GetCollectionsForHome2Query = {
  readonly __typename: "Query";
  readonly collections: {
    readonly __typename: "CollectionsConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasPreviousPage: boolean;
      readonly hasNextPage: boolean;
      readonly startCursor: c.Cursor | null;
      readonly endCursor: c.Cursor | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "CollectionsEdge";
      readonly node: {
        readonly __typename: "Collection";
        readonly id: c.CollectionId;
        readonly name: string;
        readonly description: string | null;
        readonly emoji: string | null;
        readonly canManage: boolean;
        readonly starredByViewer: boolean;
        readonly collectionHexLinkCountsByProjectType: {
          readonly __typename: "LinkCountsByProjectType";
          readonly projectCount: number;
          readonly componentCount: number;
        };
        readonly collectionGrants: ReadonlyArray<{
          readonly __typename: "CollectionGrant";
          readonly id: c.CollectionGrantId;
          readonly role: Types.CollectionRole;
          readonly holder:
            | {
                readonly __typename: "Group";
                readonly groupId: c.GroupId;
                readonly groupName: string;
              }
            | {
                readonly __typename: "IntrinsicGroup";
                readonly intrinsicGroupId: Types.IntrinsicGroupId;
              }
            | {
                readonly __typename: "User";
                readonly name: string | null;
                readonly email: string;
                readonly active: boolean;
                readonly imageUrl: string | null;
                readonly orgRole: Types.OrgRole;
                readonly userId: c.UserId;
              };
        }>;
      };
    }>;
  };
};

export const CollectionForHomeFragmentDoc = /*#__PURE__*/ gql`
  fragment CollectionForHomeFragment on Collection {
    id
    name
    description
    emoji
    canManage
    collectionHexLinkCountsByProjectType {
      projectCount
      componentCount
    }
    collectionGrants {
      id
      ...CollectionGrantFragment
    }
    starredByViewer
  }
  ${CollectionGrantFragmentDoc}
`;
export const GetCollectionsForHome2Document = /*#__PURE__*/ gql`
  query GetCollectionsForHome2(
    $ownershipLevel: CollectionOwnershipLevel!
    $searchTerm: String
    $order: CollectionOrder
    $first: Int
    $last: Int
    $before: Cursor
    $after: Cursor
  ) {
    collections(
      ownershipLevel: $ownershipLevel
      searchTerm: $searchTerm
      order: $order
      first: $first
      last: $last
      before: $before
      after: $after
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          ...CollectionForHomeFragment
        }
      }
    }
  }
  ${CollectionForHomeFragmentDoc}
`;

/**
 * __useGetCollectionsForHome2Query__
 *
 * To run a query within a React component, call `useGetCollectionsForHome2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsForHome2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsForHome2Query({
 *   variables: {
 *      ownershipLevel: // value for 'ownershipLevel'
 *      searchTerm: // value for 'searchTerm'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCollectionsForHome2Query(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionsForHome2Query,
    GetCollectionsForHome2QueryVariables
  > &
    (
      | { variables: GetCollectionsForHome2QueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionsForHome2Query,
    GetCollectionsForHome2QueryVariables
  >(GetCollectionsForHome2Document, options);
}
export function useGetCollectionsForHome2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionsForHome2Query,
    GetCollectionsForHome2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionsForHome2Query,
    GetCollectionsForHome2QueryVariables
  >(GetCollectionsForHome2Document, options);
}
export function useGetCollectionsForHome2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCollectionsForHome2Query,
    GetCollectionsForHome2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCollectionsForHome2Query,
    GetCollectionsForHome2QueryVariables
  >(GetCollectionsForHome2Document, options);
}
export type GetCollectionsForHome2QueryHookResult = ReturnType<
  typeof useGetCollectionsForHome2Query
>;
export type GetCollectionsForHome2LazyQueryHookResult = ReturnType<
  typeof useGetCollectionsForHome2LazyQuery
>;
export type GetCollectionsForHome2SuspenseQueryHookResult = ReturnType<
  typeof useGetCollectionsForHome2SuspenseQuery
>;
export type GetCollectionsForHome2QueryResult = Apollo.QueryResult<
  GetCollectionsForHome2Query,
  GetCollectionsForHome2QueryVariables
>;
